<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Detail Titip Jual
            </h5>
            <hr />

            <b-row>
                <b-col md="3">
                    <b-form-group label="Kode Titip Jual">
                        <b-form-input
                            v-model="filter.code"
                            maxlength="50"
                            placeholder="Masukkan Kode Titip Jual..."
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input
                            v-model="filter.noFaktur"
                            maxlength="50"
                            placeholder="Masukkan No. Faktur PGI..."
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="IMEI / SN">
                        <b-form-input
                            v-model="filter.imeiSn"
                            maxlength="100"
                            placeholder="Masukkan IMEI / SN..."
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status">
                        <b-form-select
                            id="filter-status"
                            v-model="filter.status"
                            :options="optStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12" class="text-right mb-3">
                    <b-button
                        :disabled="isBusy"
                        variant="primary"
                        @click="getItems"
                    >
                    <i class="fa fa-fw fa-search ml-2" />
                        Cari
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                :busy="isBusy"
                no-local-sorting
                :items="items"
                :fields="fields"
                responsive
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(fakturimei)="row">
                    NF <strong>{{ row.item.no_faktur || "-" }}</strong>
                    <div class="small text-muted">
                        IMEI <strong>{{ row.item.imei_sn || "-" }}</strong>
                    </div>
                </template>
                <template v-slot:cell(barang)="row">
                    <strong class="large">{{ row.item.name }}</strong>
                    <br />
                    <span class="text-muted small">{{
                        row.item.kind_name
                    }}</span>
                    <br />
                    Harga:
                    <strong
                        >Rp.
                        {{ $helper.formatThousand(row.item.capital) }}</strong
                    >
                    <br />
                    Kelengkapan:
                    <strong>{{
                        row.item.is_fullset == 1 ? "Lengkap" : "Batangan"
                    }}</strong>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseStatus(row.item.status)[0]">
                        {{ parseStatus(row.item.status)[1] }}
                    </b-badge>
                </template>

                <template v-slot:cell(action)="row">
                    <div v-if="row.item.active_variance_id">
                        <b-badge :variant="getVarianceStatusBadge(row.item.active_variance_status).variant">
                            {{ getVarianceStatusBadge(row.item.active_variance_status).text }}
                        </b-badge>
                        <div class="mt-1">
                            <router-link :to="'/inventory-temuan/' + row.item.active_variance_id">
                                Lihat Temuan
                            </router-link>
                        </div>
                    </div>
                    <template v-else-if="row.item.status == 1">
                        <b-button
                            variant="success"
                            v-b-tooltip.hover.top
                            title="Approve"
                            @click="showModal(row.item)"
                        >
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button
                            v-if="canCreateVariance"
                            variant="danger"
                            class="ml-1"
                            v-b-tooltip.hover.top
                            title="Buat Temuan"
                            @click="showVarianceModal(row.item)"
                        >
                            <i class="fa fa-fw fa-question" />
                        </b-button>
                    </template>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <ModalInputTitipJual
            ref="modalInputTitipJual"
            :item="selectedItem"
            @refresh="getItems"
        />

        <ModalDataPerubahan
            context="consignment"
            :consignment-code="varianceItem ? varianceItem.code : ''"
            :batch-id="varianceItem ? varianceItem.batch_id : null"
            :defaults="varianceDefaults"
            @saved="getItems(currentPage)"
        />
    </div>
</template>

<script>
import EnumPermission from "@/shared/enum-permissions";
import { getVarianceStatusBadge } from "@/shared/inventory-variance";
import ModalInputTitipJual from "./ModalInputTitipJual.vue";
import ModalDataPerubahan from "../temuan-inventory/ModalDataPerubahan.vue";

export default {
    components: {
        ModalInputTitipJual,
        ModalDataPerubahan
    },
    data() {
        return {
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,
            isShowing: false,

            data: {},
            items: [],

            filter: {
                code: "",
                imeiSn: "",
                noFaktur: "",
                status: null
            },

            fields: [
                { key: "code", label: "Kode Titip Jual", sortable: false },
                {
                    key: "fakturimei",
                    label: "Faktur & IMEI / SN",
                    sortable: false
                },
                { key: "barang", label: "Barang", sortable: true },
                { key: "status", label: "Status", sortable: false },
                { key: "note", label: "Catatan", sortable: false },
                { key: "action", label: "Aksi", sortable: false }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            optStatus: [
                { value: null, text: "Semua" },
                { value: 1, text: "PENDING" },
                { value: 2, text: "APPROVED" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,

            selectedItem: null,
            varianceItem: null
        };
    },

    computed: {
        canCreateVariance() {
            return [EnumPermission.INVENTORY_VARIANCE, EnumPermission.APPROVE_CONSIGNMENT].some(p =>
                this.$helper.isAllowed(p.toString())
            );
        },
        // Same shape as the BE origin_data: GA names as reference only
        varianceDefaults() {
            const item = this.varianceItem;
            if (!item) return null;
            return {
                item_kind: item.kind_name,
                item_type: item.name,
                imei_sn: item.imei_sn,
                is_batangan: !Number(item.is_fullset),
                capital: item.capital,
                description: item.note
            };
        }
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page) {
            this.isBusy = true;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (this.filter.code) {
                param += `&code=${this.filter.code}`;
            }

            if (this.filter.noFaktur) {
                param += `&no_faktur=${this.filter.noFaktur}`;
            }

            if (this.filter.imeiSn) {
                param += `&imei_sn=${this.filter.imeiSn}`;
            }

            if (this.filter.status) {
                param += `&status=${this.filter.status}`;
            }

            return this.$axios
                .get("consignment/" + this.$route.params.id + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                });
        },

        showModal(item) {
            if (item.status == 2) {
                this.$helper.toastError(this, "Barang sudah disetujui");
                return;
            }

            this.selectedItem = item;
            this.$refs.modalInputTitipJual.$bvModal.show("m-input-titip-jual");
        },

        showVarianceModal(item) {
            this.varianceItem = item;
            this.$nextTick(() => this.$bvModal.show("m-data-perubahan-temuan-inventory"));
        },

        getVarianceStatusBadge,

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        parseStatus(status) {
            switch (status) {
                case 1:
                    return ["warning", "PENDING"];
                case 2:
                    return ["success", "APPROVED"];
                default:
                    return ["light", "-"];
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style></style>
